/** Updates page copy in Arabic. Mirrors `../en/updates.js` key for key. */
export const UPDATES = {
  eyebrow: 'ملاحظات الإصدار',
  title: 'ما الجديد في MeetNPlan',
  text: 'كل إصدار من MeetNPlan، بما فيه من جديد وما تحسّن وما أصلحناه.',
  latest: 'الأحدث',
  soon: 'الإصدار الأول قريبًا',
  releasesLabel: 'الإصدارات',
  showLabel: 'عرض',
  kinds: { all: 'الكل', new: 'جديد', improved: 'تحسينات', fixed: 'إصلاحات' },
  none: 'لا يوجد شيء من هذا النوع بعد.',
  empty: {
    title: 'لا توجد ملاحظات إصدار بعد',
    text: 'عندما نطلق شيئًا جديدًا أو نحسّن ميزة أو نصلح خطأ، ستجده هنا.',
  },
  report: {
    title: 'لاحظت خطأً أو شيئًا لا يعمل؟',
    text: 'أخبرنا بما حدث وسنتحقق منه. لقطة الشاشة تساعد.',
    cta: { label: 'أبلغ عن مشكلة', href: '/contact' },
  },
  releases: [
    {
      version: 'v2.4',
      date: '20 أكتوبر 2026',
      title: 'المراسلة ودعوة الضيوف',
      summary:
        'يمكن لفريقك الآن التحدث داخل MeetNPlan، ويمكنك دعوة أشخاص من خارج الشركة إلى أي اجتماع.',
      new: [
        {
          title: 'المراسلة الداخلية',
          text: 'محادثات مباشرة وجماعية ومحادثات للاجتماعات، مع إشعارات القراءة والردود ومشاركة الملفات.',
        },
        {
          title: 'دعوة العملاء',
          text: 'ادعُ أشخاصًا من خارج الشركة، ويُميَّزون كضيوف خارجيين.',
        },
      ],
      fixed: [
        {
          title: 'عدّاد غير المقروء يُمسح الآن',
          text: 'كانت شارة غير المقروء تبقى ظاهرة بعد قراءة المحادثة، وأصبحت تختفي فورًا.',
        },
      ],
    },
    {
      version: 'v2.3',
      date: '2 أكتوبر 2026',
      title: 'دعوات أسرع عبر البريد',
      summary: 'أصبح إرسال الدعوات والرد عليها بنقرة واحدة.',
      new: [
        {
          title: 'دعوات البريد بنقرة واحدة',
          text: 'أرسل دعوات الاجتماعات عبر البريد بنقرة واحدة، مع تتبّع ردود كل مدعو.',
        },
      ],
      improved: [
        {
          title: 'تقويم أسرع',
          text: 'يُحمَّل عرض الأسبوع أسرع بنحو الضعف لدى الفرق الكبيرة.',
        },
      ],
    },
    {
      version: 'v2.2',
      date: '18 سبتمبر 2026',
      title: 'مزامنة التقويم',
      summary: 'تظهر الاجتماعات الآن في التقويمات التي يستخدمها فريقك بالفعل.',
      new: [
        {
          title: 'تقويم Google',
          text: 'تتزامن الاجتماعات مع تقويم Google، وتُرسل الدعوات بالبريد الإلكتروني.',
        },
      ],
      fixed: [
        {
          title: 'المنطقة الزمنية في الدعوات',
          text: 'تعرض الدعوات المرسلة بين مناطق زمنية مختلفة الوقت المحلي الصحيح.',
        },
      ],
    },
    {
      version: 'v2.1',
      date: '4 سبتمبر 2026',
      title: 'قاعات أفضل',
      summary: 'أصبح إعداد القاعات أوضح، وحالتها مباشرة.',
      improved: [
        {
          title: 'إدارة القاعات',
          text: 'أعدّ القاعات بسعتها وتجهيزاتها، واعرف المتاح منها الآن.',
        },
      ],
      fixed: [
        {
          title: 'صور القاعات',
          text: 'لم تعد صور القاعات تظهر ممددة على الهواتف.',
        },
      ],
    },
    {
      version: 'v2.0',
      date: '20 أغسطس 2026',
      title: 'MeetNPlan 2.0',
      summary: 'مظهر جديد في اللوحات الأربع، مع دعم كامل للعربية.',
      new: [
        {
          title: 'تصميم جديد',
          text: 'تخطيط أنظف في لوحات المستخدم والاستقبال والموارد البشرية والمسؤول.',
        },
        {
          title: 'العربية أولًا',
          text: 'واجهة كاملة من اليمين إلى اليسار ونصوص عربية، مع الإنجليزية بنقرة واحدة.',
        },
      ],
    },
  ],
}
